import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

function Navigation() {
  const [services, setServices] = useState([]);
  const [expanded, setExpanded] = useState(false); // ✅ Track collapse
  const location = useLocation();

  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetch(`${baseURL}/services-page.php`)
      .then(response => response.json())
      .then(data => setServices(data))
      .catch(error => console.error('Error fetching services:', error));
  }, [baseURL]);

  // ✅ Collapse menu when route changes
  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  return (
    <Navbar 
      bg="white" 
      expand="lg" 
      sticky="top" 
      className="shadow-sm"
      expanded={expanded}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img 
            src="/assets/pllogo.jpeg" 
            alt="Precision Analytical Lab Solutions"
            height="50"
            className="d-inline-block align-top me-2"
          />
          <div className="d-flex flex-column">
            <span className="royal-blue-text fw-bold" style={{ fontSize: '1.1rem', lineHeight: '1.2' }}>
              PRECISION ANALYTICAL LAB SOLUTIONS
            </span>
            <small className="text-muted" style={{ fontSize: '0.7rem' }}>
              East Africa Ltd
            </small>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle onClick={() => setExpanded(expanded ? false : true)} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className={location.pathname === '/' ? 'active fw-bold' : ''}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className={location.pathname === '/about' ? 'active fw-bold' : ''}>
              About Us
            </Nav.Link>
            <Nav.Link as={Link} to="/services" className={location.pathname === '/services' ? 'active fw-bold' : ''}>
              Our Services
            </Nav.Link>
            <Nav.Link as={Link} to="/industries" className={location.pathname === '/industries' ? 'active fw-bold' : ''}>
              Industries
            </Nav.Link>
            <Nav.Link as={Link} to="/clients" className={location.pathname === '/clients' ? 'active fw-bold' : ''}>
              Our Clients
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className={location.pathname === '/contact' ? 'active fw-bold' : ''}>
              Contact
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/booking" 
              className="btn btn-primary text-white ms-2 px-3"
            >
              <i className="fas fa-calendar-check me-2"></i>
              Request for Quote
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
